import { useSettings } from "@/lib/settings";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const { settings } = useSettings();
  const wa = settings?.whatsapp_auto || {};
  const num = (wa.business_number || settings?.contact?.whatsapp || "").replace(/[^0-9]/g, "");
  if (!num) return null;
  const message = encodeURIComponent(wa.greeting || "Hi EQtech Academy, I want to know more about your courses.");
  const pos = wa.position === "bottom-right" ? "right-24" : "left-6"; // avoid overlap with chatbot (right-6)
  return (
    <a
      href={`https://wa.me/${num}?text=${message}`}
      target="_blank" rel="noreferrer"
      data-testid="whatsapp-float"
      className={`fixed bottom-6 ${pos} z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-lg flex items-center justify-center transition-transform hover:scale-110`}
      title="WhatsApp us"
    >
      <MessageCircle className="w-7 h-7 text-white" fill="white" strokeWidth={1.5} />
    </a>
  );
}
